import type { OfferPageDispatchAction, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import offerPageStateReducer, { INITIAL_OFFER_PAGE_STATE } from 'contexts/OfferPage/offerPageStateReducer'
import { EmptyArray } from 'lib/array/arrayUtils'
import type { ReducerMiddleware } from 'lib/redux/reducerUtils'
import type { Dispatch } from 'react'
import { useReducer } from 'react'

function useOfferPageReducer(
  defaultState: Partial<OfferPageState>,
  middlewares: Array<ReducerMiddleware<OfferPageState, OfferPageDispatchAction>> = EmptyArray,
): [state: OfferPageState, dispatch: Dispatch<OfferPageDispatchAction>] {
  return useReducer(offerPageStateReducer(middlewares, true), { ...INITIAL_OFFER_PAGE_STATE, ...defaultState })
}

export default useOfferPageReducer
